/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconAlignCenter = createReactComponent("outline", "align-center", "IconAlignCenter", [["path", { "d": "M4 6l16 0", "key": "svg-0" }], ["path", { "d": "M8 12l8 0", "key": "svg-1" }], ["path", { "d": "M6 18l12 0", "key": "svg-2" }]]);

export { IconAlignCenter as default };
//# sourceMappingURL=IconAlignCenter.mjs.map
